import { useEffect, useState } from "react";
import Image from "next/image";
import { Link } from "rebass";
import { ThemeProvider } from "@mui/material/styles";
import theme from "../../styles/LLTheme";
import { Heading, Text, Flex, Box } from "rebass";
import dynamic from "next/dynamic";
import Textra from "../textra";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown } from '@fortawesome/free-solid-svg-icons'
const Spline = dynamic(() => import("@splinetool/react-spline"), {
  ssr: false,
});
// import Lottie from "lottie-react";
// import download from "../../public/lottie/download.json";

const Landing = () => {

  const images = ["/images/exp.png", "/images/box.png", "/images/joystick.png", "/images/pig.png"]

  return (
    <ThemeProvider theme={theme}>
      <Flex
        sx={{
          width: "100%",
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        //   padding: "10px",
        }}
      >
        <Flex
          sx={{
            flexGrow: 1,
            flexDirection: "column",
            zIndex: 100,
            alignItems: "center",
          }}
        >
          <Text
            sx={{
              color: "rgba(255,255,255, 0.5)",
              fontFamily: "Montserrat,sans-serif",
              fontWeight: "bold",
              textTransform: "lowercase",
              position: "relative" 
            }}
            fontSize={["2em", "2.2em", "3.5em"]}
          >
            # the wallet built for
          </Text>


          <Flex
            fontSize={["4em", "6em", "8em"]}
            sx={{ fontFamily: "Inter,sans-serif", fontWeight: "bold", width: '100%', textAlign: "center", justifyContent: "center"}}
          >
            <Textra
              images={images}
              effect="downTop"
              data={["explorers", "collectors", "gamers", "everyone"]}
            />
          </Flex>
          <Text
            sx={{
              color: "#F9F9F9",
              fontFamily: "Inter,sans-serif",
              fontWeight: 400,
              mt: "20px",
              display: "flex",
              alignItems: "center",
              // fontWeight: 'Bold',
              mb: "50px",
            }}
            fontSize={["1rem", "1.25rem", "1.5rem"]}
          >
            Enter the
            <span style={{ whiteSpace: "pre", color: "#11EF8B" }}>
              {" "}
              flow-verse
            </span>
            <Spline
              scene="https://prod.spline.design/vDVSEYGNSW6QFD7L/scene.splinecode"
              style={{ width: "50px", height: "50px", display: "inline-block" }}
            />
            with lilico
          </Text>
          <Link href="/download" >
          <Flex
            sx={{
              display: "flex",
              px: "12px",
              backgroundColor: "#fcfcfc",
              borderRadius: "999px",
              pl: "18px",
              alignItems: "center",
              transition: 'transform .2s',
              cursor: 'pointer',
              ':hover': {
                backgroundColor: "#f0f0f0",
                transform: 'scale(0.95)'
              }
            }}
            //   disableRipple={true}
          >
            {/* <Lottie animationData={download} style={{height: "40px", width: "40px", marginLeft: "15px" }}/> */}
            {/* <FontAwesomeIcon icon={faArrowDown} style={{ color: "#FC814A", fontSize: "25px", zIndex: 99, marginLeft: "5px" }} /> */}
            <Text
              variant="body1"
              px="20px"
              py="20px"
              sx={{
                color: "#121212",
                fontWeight: "bold",
                textTransform: "capitalize",
                fontFamily: "Inter,sans-serif",
              }}
              fontSize={["1.0em", "1.1em", "1.3em"]}
            >
              Download
            </Text>
            {/* <Image src="/Chrome.svg" width="65" height="65" alt="chrome" /> */}
          </Flex>
          </Link>
        </Flex>
      </Flex>
    </ThemeProvider>
  );
};

export default Landing;
